<template>
  <div>
    <v-footer inset fixed flat padless class="hidden-sm-and-up">
      <v-card
        flat
        tile
        width="100%"
        class="text-center"
        :color="$vuetify.theme.dark ? 'grey darken-3' : 'white lighten-1 '"
      >
        <v-card-text>
          <v-row align="center" justify="space-around">
            <v-col>
              <v-row align="center" justify="space-around">
                <v-btn
                  v-if="hasPrev"
                  class="ma-2"
                  elevation="0"
                  rounded
                  :color="$vuetify.theme.dark ? 'grey darken-3' : 'white'"
                  @click="emitPrev"
                >
                  {{ $t("back") }}
                </v-btn>
              </v-row>
            </v-col>
            <v-col>
              <v-row align="center" justify="space-around">
                <v-btn v-if="hasNext" class="ma-2" rounded color="success" @click="emitNext" :disabled="disableNext">
                  {{ $t("next") }}
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-footer>
    <v-container>
      <v-card-actions v-if="hasPrev" class="progressContainer card-actions hidden-sm-and-down d-sm-inline">
        <v-row>
          <v-col>
            <v-row justify="start">
              <v-btn id="prev" large rounded v-if="hasPrev" elevation="0" @click="emitPrev">
                <v-icon>mdi-arrow-left</v-icon>
                {{ $t("back") }}
              </v-btn>
            </v-row>
          </v-col>
          <v-col>
            <v-row justify="end">
              <v-btn
                id="next"
                :disabled="disableNext"
                large
                rounded
                v-if="hasNext"
                color="green"
                elevation="0"
                @click="emitNext"
              >
                {{ $t("next") }}
                <v-icon>mdi-arrow-right</v-icon>
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-container>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class BackAndFortFooter2 extends Vue {
  @Prop({ default: true })
  hasNext!: boolean;

  @Prop({ default: true })
  hasPrev!: boolean;

  @Prop({ default: false })
  disableNext!: boolean;

  emitNext() {
    this.$emit("next", true);
  }
  emitPrev() {
    this.$emit("prev", true);
  }
}
</script>
<style scoped>
.progressContainer {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding-left: 28px !important;
  padding-right: 28px !important;
}

.bottomContainer {
  width: 80%;
}
</style>
